import React from 'react'
import clsx from 'clsx'
import {Dropdown, Form, Button} from 'react-bootstrap'
import {KTIcon} from '../../_metronic/helpers'
import FilterForm from './FilterForm'
import {useFilterState} from './useFilterState'
import {FilterDropdownProps} from './types'

const TableFilterDropdown: React.FC<FilterDropdownProps> = ({
  fields,
  onApply,
  onReset,
  buttonClassName,
  menuStyles,
  colProps,
}) => {
  const {filters, showDropdown, setShowDropdown, handleChange, resetFilters} =
    useFilterState(fields)

  const handleApply = () => {
    onApply(filters)
    setShowDropdown(false)
  }

  const handleReset = () => {
    resetFilters()
    onReset()
    setShowDropdown(false)
  }

  return (
    <Dropdown align="start" show={showDropdown} onToggle={setShowDropdown}>
      <Dropdown.Toggle
        variant="outline-light"
        className={clsx('border border-secondary fw-bold', buttonClassName)}
        size="sm"
      >
        <KTIcon iconName="filter" iconType="solid" className="fs-5" />
        Filters
      </Dropdown.Toggle>

      <Dropdown.Menu style={{padding: '1rem', minWidth: '250px', ...menuStyles}}>
        <Form>
          <FilterForm
            fields={fields}
            filters={filters}
            onChange={handleChange}
            colProps={colProps}
          />

          <div className="d-flex justify-content-between py-2">
            <Button
              size="sm"
              className="rounded-3 w-100px"
              variant="secondary"
              onClick={handleReset}
            >
              Reset All
            </Button>
            <Button size="sm" className="rounded-3 w-100px" variant="primary" onClick={handleApply}>
              Apply
            </Button>
          </div>
        </Form>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default TableFilterDropdown
